import { useNavigate } from "react-router-dom";
import { PageShell } from "@/components/PageShell";
import { BrandHeader } from "@/components/BrandHeader";
import { Button } from "@/components/Button";
import "./edge.css";

export function TripGoneScreen() {
  const navigate = useNavigate();
  return (
    <PageShell header={<BrandHeader />}>
      <section className="wp-edge">
        <div className="wp-edge__glyph" aria-hidden="true">⌕</div>
        <h1 className="wp-edge__title">Такої поїздки немає</h1>
        <p className="wp-edge__hint">
          Можливо: лінку оновили, поїздку видалили понад 7 днів тому, або
          адресу набрано неточно.
        </p>
        <Button size="lg" onClick={() => navigate("/")}>
          Створити нову поїздку
        </Button>
        <p className="wp-edge__hint">
          Якщо в тебе є друга версія лінки — спробуй відкрити її.
        </p>
      </section>
    </PageShell>
  );
}
